module.exports = __webpack_public_path__ + "static/media/UsersFour.6d72e952.svg";